import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import {
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Entry2xmjmyutzoq3p as Entry,
} from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysClass;
function HashMapKeys() {
  if (HashMapKeysClass === VOID) {
    class $ extends AbstractMutableSet() {
      static p9(backing) {
        var $this = this.g8();
        $this.o9_1 = backing;
        return $this;
      }
      v2() {
        return this.o9_1.v2();
      }
      s1() {
        return this.o9_1.v2() === 0;
      }
      y2(element) {
        return this.o9_1.n9(element);
      }
      f5() {
        return this.o9_1.f5();
      }
      n2(element) {
        throw UnsupportedOperationException().o8();
      }
      z2(elements) {
        throw UnsupportedOperationException().o8();
      }
      u1() {
        return this.o9_1.u9();
      }
      t6() {
        return this.o9_1.v9();
      }
    }
    initMetadataForClass($, 'HashMapKeys', VOID, VOID, [KtMutableSet(), AbstractMutableSet()]);
    HashMapKeysClass = $;
  }
  return HashMapKeysClass;
}
var HashMapValuesClass;
function HashMapValues() {
  if (HashMapValuesClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static r9(backing) {
        var $this = this.r6();
        $this.q9_1 = backing;
        return $this;
      }
      v2() {
        return this.q9_1.v2();
      }
      s1() {
        return this.q9_1.v2() === 0;
      }
      w9(element) {
        return this.q9_1.y4(element);
      }
      y2(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.w9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      x9(element) {
        throw UnsupportedOperationException().o8();
      }
      n2(element) {
        return this.x9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      y9(elements) {
        throw UnsupportedOperationException().o8();
      }
      z2(elements) {
        return this.y9(elements);
      }
      u1() {
        return this.q9_1.z9();
      }
      t6() {
        return this.q9_1.v9();
      }
    }
    initMetadataForClass($, 'HashMapValues', VOID, VOID, [Collection(), MutableIterable(), AbstractMutableCollection()]);
    HashMapValuesClass = $;
  }
  return HashMapValuesClass;
}
var HashMapEntrySetClass;
function HashMapEntrySet() {
  if (HashMapEntrySetClass === VOID) {
    class $ extends HashMapEntrySetBase() {
      static t9(backing) {
        return this.ba(backing);
      }
      u1() {
        return this.aa_1.ca();
      }
    }
    initMetadataForClass($, 'HashMapEntrySet');
    HashMapEntrySetClass = $;
  }
  return HashMapEntrySetClass;
}
var HashMapEntrySetBaseClass;
function HashMapEntrySetBase() {
  if (HashMapEntrySetBaseClass === VOID) {
    class $ extends AbstractMutableSet() {
      static ba(backing) {
        var $this = this.g8();
        $this.aa_1 = backing;
        return $this;
      }
      v2() {
        return this.aa_1.v2();
      }
      s1() {
        return this.aa_1.v2() === 0;
      }
      da(element) {
        return this.aa_1.fa(element);
      }
      y2(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.da((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      f5() {
        return this.aa_1.f5();
      }
      ea(element) {
        throw UnsupportedOperationException().o8();
      }
      n2(element) {
        return this.ea((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      z2(elements) {
        throw UnsupportedOperationException().o8();
      }
      v4(elements) {
        return this.aa_1.ga(elements);
      }
      t6() {
        return this.aa_1.v9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySetBase', VOID, VOID, [KtMutableSet(), AbstractMutableSet()]);
    HashMapEntrySetBaseClass = $;
  }
  return HashMapEntrySetBaseClass;
}
//region block: exports
export {
  HashMapEntrySet as HashMapEntrySet29p2ksc4wcy5i,
  HashMapKeys as HashMapKeys28ggmxpft3hz9,
  HashMapValues as HashMapValues3umcxpfyfunqf,
};
//endregion

//# sourceMappingURL=HashMapEntry.mjs.map
